import { render, staticRenderFns } from "./ConferenceTable.vue?vue&type=template&id=10293bb3&"
import script from "./ConferenceTable.vue?vue&type=script&lang=js&"
export * from "./ConferenceTable.vue?vue&type=script&lang=js&"
import style0 from "./ConferenceTable.vue?vue&type=style&index=0&id=10293bb3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports